<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtRouteAnnouncer />
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
const layoutWatcher = useLayoutWatchers();
const { initTheme } = useTheme();

onMounted(() => {
  initTheme();
  layoutWatcher.initWatchers();
});

</script>